import { createBootstrap } from "../../bootstrap";

export default createBootstrap("accounts", "institution");
